import type {
	ReturnRequestDto,
	UpdateLineItemDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseApproveOrRejectReturnParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
	shopId: string;
	returnRequestId: string;
}

export default function useEditLineItem(
	params: UseApproveOrRejectReturnParams,
) {
	return useApiMutation(
		"patch",
		"/shops/{shopId}/return-requests/{returnRequestId}/line-items/{lineItemId}",
		{
			notify: false,
			onSuccess: (result: ReturnRequestDto) => {
				params.onSuccess(result);
			},
			mapVariables: ({
				lineItemId,
				requestBody,
			}: {
				lineItemId: string;
				requestBody: UpdateLineItemDto;
			}) => ({
				params: {
					path: {
						shopId: params.shopId,
						returnRequestId: params.returnRequestId,
						lineItemId,
					},
				},
				body: requestBody,
			}),
		},
	);
}
